export default "__VITE_ASSET___nolLnnY__"